var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isDebug)?_c('pre',[_vm._v("  "+_vm._s(_vm.debug)+"\n   "),_vm._t("default"),_vm._v("\n")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }